import { usePermissions } from '@customerio/hydra-permissions/react';
import { Navigate } from 'react-router-dom';
import { useCurrentWorkspace } from '../context/current-workspace';
import { workspaceRootUrl } from '@/utils/navigation';

export function Index() {
  const currentWorkspace = useCurrentWorkspace();
  const { hasPermission } = usePermissions();

  if (currentWorkspace == null) {
    if (hasPermission('account/billing/view') === true) {
      return <Navigate to="settings/billing/your-plan" replace={true} />;
    }

    return <Navigate to="settings" replace={true} />;
  }

  const path = `${workspaceRootUrl(currentWorkspace.id)}${window.location.search}`;
  return <Navigate to={path} replace={true} />;
}
